<template>
    <v-container>
        <v-layout justify-center fill-height class="my-16">
            <v-flex class="d-flex flex-column" style="gap: 24px">
              <div class="d-flex justify-center">
                <v-img
                    eager
                    :src="require('../assets/Search_Error.png')"
                    max-width="150"
                ></v-img>
              </div>
              <div class="notfound-text">
                <b>ไม่พบหน้าที่ค้นหา</b> โปรดตรวจสอบ URL หรือ
                <a href="/" style="color: #2e8037 !important; text-decoration: underline !important;">กลับไปยังหน้าแรก</a>
              </div>
              <div class="notfound-text">
                <b>Page not found</b> the requested page couldn't be located. Please recheck the spelling of the URL or
                <a href="/" style="color: #2e8037 !important; text-decoration: underline !important;">return to homepage</a>
              </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "Notfound"
    }
</script>

<style scoped>
.notfound-text {
  font-size: 20px;
  text-align: center;
  font-family: "Poppins", "Kanit", sans-serif;
}
</style>
